import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { publishReplay, refCount } from 'rxjs/operators';
import 'rxjs/Rx';
import { Observable } from 'rxjs/Rx';
import { Toponym } from '../../models/toponym.model';
import { HttpClientService } from '../httpClient/httpclient.service';

@Injectable()
export class ToponymService {

  toponyms: Toponym[];
  toponymEditing: Toponym;
  private cachedFields: Observable<any>;

  constructor (
    private h: HttpClientService,
    private srvNotify: MessageService
  ) { }

  getAll() {
    return this.h.get('/koncentro-common/toponym/toponyms/')
      .map(res => {
        return this.toponyms = res;
      });
  }

  delete(record) {
    return this.h.delete('/koncentro-common/toponym/toponyms/' + record.id)
      .map(res => {
        this.toponyms.splice(this.toponyms.indexOf(record), 1);
        this.srvNotify.add({severity: 'info', summary: 'Confirmed', detail: 'Toponym deleted'});
      });
  }

  post(newData) {
    return this.h.post('/koncentro-common/toponym/toponyms/', newData)
      .map(res => {
        newData.id = res.id;
        this.toponyms.push(newData);
        this.srvNotify.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });

  }

  put(newData) {
    return this.h.put('/koncentro-common/toponym/toponyms/', newData)
      .map(res => {
        Object.assign(this.toponymEditing, newData);
        this.srvNotify.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });
  }

  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.h.get('/koncentro-common/schema/ToponymDto').pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/toponym/toponym.service.ts